import { leadHousingPlanConstants } from './leadHousingPlan.Constants';

export function storeHousingPlanData(data) {
  return dispatch => {
    dispatch({ type: leadHousingPlanConstants.STORE_HOUSINGPLANDATA, data });
  }
}